import { atom } from 'recoil';

export const shareModalVisibleState = atom<boolean>({
  key: 'shareModalVisibleState',
  default: false,
});
